/* FutureSelf RX homepage hero: particle-to-vial intro.
   Dots drift across the hero, stream into the shape of the active vial photo,
   then the real photo fades in. Plays once on load and again on slide change.
   Standalone: remove this script tag from layout/fs-home.liquid to revert. */
(()=>{
 const hero=document.querySelector('.fsh-hero'),visual=hero&&hero.querySelector('.fsh-hero-visual');
 if(!hero||!visual||hero.dataset.fx)return;
 let force=false;
 try{const q=new URLSearchParams(location.search).get('fx');if(q==='1')localStorage.setItem('fsFx','1');if(q==='0')localStorage.removeItem('fsFx');force=localStorage.getItem('fsFx')==='1';}catch(e){}
 if(matchMedia('(prefers-reduced-motion: reduce)').matches&&!force)return;
 hero.dataset.fx='on';
 const css=document.createElement('style');
 css.textContent='.fsh-hero[data-fx]>*{position:relative}.fsh-hero[data-fx]>.fsh-fx-canvas{position:absolute;inset:0;width:100%;height:100%;pointer-events:none}.fsh-hero[data-fx] .fsh-hero-slide img{animation:none}.fsh-hero[data-fx] .fsh-hero-slide img.fsh-fx-hide{opacity:0}';
 document.head.appendChild(css);
 const canvas=document.createElement('canvas');canvas.className='fsh-fx-canvas';canvas.setAttribute('aria-hidden','true');hero.prepend(canvas);
 const ctx=canvas.getContext('2d');
 const clamp=(v,a,b)=>Math.max(a,Math.min(b,v)),ease=t=>t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;
 const BUCKETS=14,READY_MS=1200;let raf=0,run=0;

 function fit(img,bw,bh,cover){const iw=img.naturalWidth,ih=img.naturalHeight,s=cover?Math.max(bw/iw,bh/ih):Math.min(bw/iw,bh/ih);return{w:iw*s,h:ih*s,x:(bw-iw*s)/2,y:(bh-ih*s)/2};}

 function sample(img,bw,bh,cover,count){
  const c=document.createElement('canvas');c.width=Math.ceil(bw);c.height=Math.ceil(bh);
  const g=c.getContext('2d',{willReadFrequently:true}),f=fit(img,bw,bh,cover);
  g.drawImage(img,f.x,f.y,f.w,f.h);
  const d=g.getImageData(0,0,c.width,c.height).data,pts=[],step=2;
  for(let y=0;y<c.height;y+=step)for(let x=0;x<c.width;x+=step){
   const i=(y*c.width+x)*4,l=.2126*d[i]+.7152*d[i+1]+.0722*d[i+2];
   if(l>15&&Math.random()<.3+l/200)pts.push(x,y,l);
  }
  const n=pts.length/3,out=[];if(!n)return out;
  for(let k=0;k<count;k++){const j=Math.floor(Math.random()*n)*3;out.push({x:pts[j]+(Math.random()-.5)*1.6,y:pts[j+1]+(Math.random()-.5)*1.6,l:pts[j+2]});}
  return out;
 }

 function reveal(){hero.querySelectorAll('.fsh-hero-slide img').forEach(el=>{el.style.opacity='';el.classList.remove('fsh-fx-hide');});}
 function finish(img){cancelAnimationFrame(raf);ctx.clearRect(0,0,canvas.width,canvas.height);if(img){img.style.opacity='';img.classList.remove('fsh-fx-hide');}}

 let current=null,currentQuick=false;

 function play(slide,quick){
  const img=slide&&slide.querySelector('img');if(!img)return;
  current=slide;currentQuick=quick;
  const id=++run;cancelAnimationFrame(raf);
  reveal();
  img.classList.add('fsh-fx-hide');
  /* The hero photo is cached on a repeat visit, so this can run before the
     browser has decoded it or settled layout. Retry until both are true
     instead of silently bailing out (that was the "only animates sometimes"
     bug) — and after READY_MS give up and just show the photo. */
  const t_wait=performance.now();
  const start=()=>{
   if(id!==run)return;
   const giveUp=()=>finish(img),again=()=>{performance.now()-t_wait>READY_MS?giveUp():requestAnimationFrame(start);};
   const hr=hero.getBoundingClientRect(),vr=visual.getBoundingClientRect();
   if(!hr.width||!vr.width||!img.naturalWidth)return again();
   const W=hr.width,H=hr.height,dpr=Math.min(window.devicePixelRatio||1,2),small=W<720;
   canvas.width=Math.floor(W*dpr);canvas.height=Math.floor(H*dpr);ctx.setTransform(dpr,0,0,dpr,0,0);
   const cover=getComputedStyle(img).objectFit==='cover';
   let pts;try{pts=sample(img,vr.width,vr.height,cover,small?4200:9000);}catch(e){return giveUp();}
   if(!pts.length)return again(); /* photo not decoded yet -> blank sample */
   const ox=vr.left-hr.left,oy=vr.top-hr.top,groups=Array.from({length:BUCKETS},()=>[]);
   for(const p of pts){
    const b=clamp(Math.floor(p.l/256*BUCKETS),0,BUCKETS-1);
    groups[b].push({tx:ox+p.x,ty:oy+p.y,sx:Math.random()*W,sy:Math.random()*H,ph:Math.random()*6.283,sp:.5+.9*Math.random(),dl:.25*Math.random()});
   }
   const colors=groups.map((_,b)=>{const v=Math.round(78+(b+.5)/BUCKETS*177);return'rgb('+v+','+v+','+Math.min(255,v+6)+')';});
   const drift=quick?.15:.8,build=quick?1.7:2.6,fade=.7,size=small?1.25:1.4;
   /* Clock starts on the first real frame and pauses with the tab: loading in a
      background tab used to throttle rAF, so the whole run elapsed unseen. */
   let t0=0,prev=0;
   const frame=now=>{
    if(id!==run)return;
    if(!t0){t0=now;prev=now;}
    if(now-prev>400)t0+=now-prev; /* tab was hidden/throttled: don't skip ahead */
    prev=now;
    const t=(now-t0)/1000,u=clamp((t-drift)/build,0,1),m=clamp((t-drift-build+.25)/fade,0,1);
    ctx.clearRect(0,0,W,H);
    ctx.globalAlpha=clamp(t/.5,0,1)*(.5+.45*u)*(1-ease(m));
    const s=size+(1-u)*.35;
    for(let b=0;b<BUCKETS;b++){
     const g=groups[b];if(!g.length)continue;ctx.fillStyle=colors[b];
     for(let k=0;k<g.length;k++){
      const p=g[k],r=ease(clamp((u-p.dl)/(1-p.dl),0,1)),loose=(1-r)*(1-.9*m);
      const x=p.sx+(p.tx-p.sx)*r+9*Math.cos(now*.001*p.sp+p.ph)*loose,y=p.sy+(p.ty-p.sy)*r+7*Math.sin(now*.0008*p.sp+p.ph)*loose;
      ctx.fillRect(x,y,s,s);
     }
    }
    img.classList.remove('fsh-fx-hide');img.style.opacity=String(ease(m));
    if(m>=1)return finish(img);
    raf=requestAnimationFrame(frame);
   };
   img.style.opacity='0';raf=requestAnimationFrame(frame);
  };
  const begin=()=>{if(id!==run)return;if(img.decode)img.decode().then(start,start);else start();};
  if(img.complete&&img.naturalWidth)begin();
  else{img.loading='eager';img.addEventListener('load',begin,{once:true});img.addEventListener('error',()=>finish(img),{once:true});}
 }

 const slides=[...hero.querySelectorAll('[data-home-slide]')];
 const active=()=>slides.find(s=>!s.hidden)||slides[0];
 play(active(),false);
 hero.querySelectorAll('[data-home-dot]').forEach((dot,i)=>dot.addEventListener('click',()=>requestAnimationFrame(()=>play(slides[i],true))));
 /* Coming back via the back button restores a finished canvas: replay it. */
 addEventListener('pageshow',e=>{if(e.persisted)requestAnimationFrame(()=>play(current||active(),true));});
 let lastW=innerWidth,rt=0;
 addEventListener('resize',()=>{
  if(Math.abs(innerWidth-lastW)<2)return;
  lastW=innerWidth;run++;finish(null);reveal();
  clearTimeout(rt);rt=setTimeout(()=>play(current||active(),true),180); /* re-fit, don't kill */
 });
})();
